const GenerateUniqueComponent = (prefix, number, digitCount) => {
    const paddedNumber = String(number).padStart(digitCount, '0');
    return `${prefix}-${paddedNumber}`;
}

export default GenerateUniqueComponent;